import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroDescription = (props: PropsWithChildren) => {
  const { children } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <BodyText sizeMatch={['16', '24']} style={styles.text}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.BROWN,
    marginVertical: theme.spacing['1'],
  },
});
